import { styled } from '@mui/material/styles'

import { GridWrapper } from '../../components'

export const GridLayout = styled(GridWrapper)(() => ({
  width: '100%',
  height: '700px',
}))
